import Radio from './radio';

function radio(props) {
  return new Radio(props);
}

// DATA-API
$(document).on('click.cd.radio.data-api', '[data-toggle="cd-radio"]', function(event) {
  event.stopPropagation();
  let $this = $(event.currentTarget);

  $this.parent().addClass('checked')
       .siblings().removeClass('checked');

});

export default radio;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/radio/index.js
// module id = 562
// module chunks = 9